module.exports = __webpack_public_path__ + "assets/6c9ec57f83d524cb5b26b350cf682efd.svg";